<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="外销合同编号：">
        <el-input size="mini" v-model="dataForm.orderCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="发货批次号：">
        <el-input size="mini" v-model="dataForm.batchCode" clearable></el-input>
      </el-form-item>

      <el-form-item prop="productCode" label="品番号：" v-if="sourceType==='make'">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：" v-if="sourceType==='make'">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="请输入颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="请输入规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：" v-if="sourceType==='purchase'">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="请输入幅宽"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：" v-if="sourceType==='purchase'">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="请输入克重"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="请输入克重"
        ></el-input>
      </el-form-item>
      <el-form-item prop="status" label="收货状态：">
        <el-select v-model="dataForm.status" placeholder="请选择" size="mini" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="未收货" value="10"></el-option>
          <el-option label="已收货" value="20"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发货时间：">
        <el-date-picker
            v-model="sendDateRange"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期" size="mini"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="收货方：">
        <el-input size="mini" v-model="dataForm.receiverName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>

    </el-form>
    <SweetTable ref="table" :selection="true" api-version="v2" url="/trade/factorystorelog/page" :auto-load="false"
                :query-form="dataForm" :before-table-binding="beforeTableBinding">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="batchCode"
          label="发货批次号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.code"
          label="品番号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          v-if="sourceType==='make'"
      ></el-table-column>
      <el-table-column
          prop="product.skuCode"
          label="SKU"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          v-if="sourceType==='make'"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.nameZh"
          label="中文品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          v-if="sourceType==='make'"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          v-if="sourceType==='purchase'"
      ></el-table-column>
      <el-table-column
          prop="product.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          v-if="sourceType==='purchase'"
      ></el-table-column>
      <el-table-column
          prop="price"
          label="发货单价"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="sendCount"
          label="发货数"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="确认收货"
          header-align="center"
          align="center"
          prop="count"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="发货时间"
          header-align="center"
          align="center"
          prop="operateTime"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="收货时间"
          header-align="center"
          align="center"
          prop="receiveOptTime"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="收货方"
          header-align="center"
          align="center"
          prop="receiverName"
          :formatter="$c.companyNameFormatter"
      >
      </el-table-column>
      <el-table-column
          label="发货操作人"
          header-align="center"
          align="center"
          prop="sendOptManName"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="收货操作人"
          header-align="center"
          align="center"
          prop="receiveOptManName"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="开票情况"
          header-align="center"
          align="center"
          width="120"
      >
        <template #default="{row}">
          <span v-if="row.status===10">未确认收货,无法开票</span>
          <span v-else-if="row.receiptDetailId">{{ row.receiptCode ? row.receiptCode : '申请中' }}</span>
          <span v-else>未开票</span>
        </template>
      </el-table-column>
    </SweetTable>
  </div>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'

export default {
  mixins: [SweetTable],
  components: {},
  data () {
    return {
      dateArr: [],
      dataForm: {
        status: null,
        orderCode: '',
        batchCode: '',
        sellerName: '',
        receiverName: '',
        productCode: '',
        skuCode: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        sourceType: this.sourceType,
        sendDateBegin: '',
        sendDateEnd: '',
        queryType: this.queryType,
        isVirtual: 1
      },
    }
  },
  props: {
    sourceType: {
      type: String,
      required: true,
      default: '',
    },
    queryType: {
      type: String,
      required: true,
      default: '',
    }
  },
  computed: {
    sendDateRange: {
      get: function () {
        return [this.dataForm.sendDateBegin, this.dataForm.sendDateEnd]
      },
      // setter
      set: function (newVal) {
        this.dataForm.sendDateBegin = newVal[0]
        this.dataForm.sendDateEnd = newVal[1]
      }
    }
  },
  watch: {
    sourceType: {
      handler: function (newVal) {
        this.dataForm.sourceType = newVal
        this.getDataList()
      },
      immediate: true
    }
  },
  methods: {
    doApplyReceipt () {
      if (!this.dataForm.sendDateBegin || !this.dataForm.sendDateEnd) {
        return this.$message.error('请选择发货时间段')
      }
      this.$api2.post(`/erp/send/apply/receipt`, {
        sendDateBegin: this.dataForm.sendDateBegin,
        sendDateEnd: this.dataForm.sendDateEnd,
        sourceType: this.sourceType
      }).then(res => {
        this.$message.success('操作成功')
        this.getDataList()
      })
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {

      })
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
